export default function LandingPage() {
    return(
        <div>
            <h1>Please Scan Your QR Code to Begin.</h1>
        </div>
    );
}